import { getProperties } from '@/libs/v1/api/client';
import Store from '@/store';

export function updateTargetName(targetName: string) {
  Store.commit('updateTargetName', targetName);
}

export function updateProperties(properties: any[]) {
  Store.commit('updateProperties', properties);
}

export async function loadProperties() {
  try {
    const properties = await getProperties();
    updateProperties(properties);
  } catch (e) {
    updateProperties([]);
    throw e;
  }
}
